import { getSonarObjectTypeApiVersion } from '../types/lib';

import { getSonarObjectTypePeriscopeRoutePart, getSonarObjectTypeSourceLabel } from '..';
import { PeriscopeCard, SonarObjectType } from '@sonar-software/sonar-ts-types';

export function displayFieldType(typeString: string): string {
	if (!typeString?.startsWith('Lookup(')) {
		return typeString;
	}

	const commaSplit = typeString?.split(',');
	const lookupCount = commaSplit?.length ?? 0;

	return lookupCount < 3 ? typeString : `${commaSplit?.slice(0, 2).join(',')}, +${lookupCount - 2})`;
}

export function findIndexForPeriscope(
	cards: Array<PeriscopeCard>,
	newPeriscopeId: string | number,
	openedFromIndex?: number
): number | null {
	if (cards.length === 0) {
		return 0;
	}

	const index = openedFromIndex ? openedFromIndex : 0;
	const [ rootPeriscope ] = cards;
	const nextPeriscope = cards[ index + 1 ];
	const currentPeriscope = cards[ index ];
	const sameAsRoot = newPeriscopeId === rootPeriscope.id;
	const sameAsNext = newPeriscopeId === nextPeriscope?.id;
	const sameAsCurrent = newPeriscopeId === currentPeriscope?.id;

	const sameAsAnyParent = cards.slice(0, index).some(
		/*	FUTURE: Remove comparison to `name` once all field endpoints are updated to
			provide the parentSonarObjectId. Matching on name (against a potential parentInternalName)
			is fuzzy and prone to edgecases. */
		(card) => card.id === newPeriscopeId || card.name === newPeriscopeId
	);

	if (!sameAsRoot && index < 0) {
		return 0;
	}

	if (sameAsRoot || sameAsNext || sameAsAnyParent || sameAsCurrent) {
		return null;
	}

	return index + 1;
}

export function getPeriscopeSummaryRouteUri(
	type: SonarObjectType | undefined,
	id: number | undefined
): string | undefined {
	if (!type || !id) {
		return undefined;
	}

	const apiVersion = getSonarObjectTypeApiVersion(type);

	if (type === SonarObjectType.SonarTag) {
		return undefined;
	}

	const sourcePart = getSonarObjectTypeSourceLabel(type)?.toLowerCase();
	const routePart = getSonarObjectTypePeriscopeRoutePart(type);

	if (!apiVersion || !sourcePart || !routePart) {
		return undefined;
	}

	return `${apiVersion}/${sourcePart}/${routePart}/${id}/summary`;
}

export function getPeriscopeMetadataRouteUri(
	type: SonarObjectType | undefined,
	id: number | undefined
): string | undefined {
	if (!type || !id || type === SonarObjectType.SonarTag) {
		return undefined;
	}

	const apiVersion = getSonarObjectTypeApiVersion(type);
	const sourcePart = getSonarObjectTypeSourceLabel(type)?.toLowerCase();
	const routePart = getSonarObjectTypePeriscopeRoutePart(type);

	if (!apiVersion || !sourcePart || !routePart) {
		return undefined;
	}

	return `${apiVersion}/${sourcePart}/${routePart}/${id}/metadata`;
}

